export default __webpack_public_path__ + "assets/images/91238a8ab9137294b6d1ceb8fbd1b563.png";